import { AISLE_WIDTH_FIXED_M, PARKING_METHOD_KEYS } from './parking/constants';
import type { ParkingMethodState, State, Zoning } from './types';

export function defaultZoning(): Zoning {
  return {
    name: '',
    bcrLimit: 60,
    farLimit: 200,
    districtType: 'none',
    road: { slopeRatio: 1.25, applyDistanceM: 20 },
    adjacent: { enabled: true, riseM: 20, slopeRatio: 1.25 },
    northSlope: { enabled: false, riseM: 5, slopeRatio: 1.25 },
  };
}

export function defaultState(): State {
  const methods = {} as Record<(typeof PARKING_METHOD_KEYS)[number], ParkingMethodState>;
  PARKING_METHOD_KEYS.forEach((key) => {
    methods[key] = { enabled: key === 'backToBack', zone: null };
  });
  return {
    site: { points: [], latlngs: [], origin: null, locked: false, edges: [] },
    buildings: [],
    zoning: defaultZoning(),
    mapView: { center: { lat: 31.616245, lng: 130.526962 }, zoom: 18 },
    ui: { mode: 'view', selectedId: null, selectedEdgeIndex: null },
    shadowCheck: {
      enabled: false,
      date: { month: 12, day: 22 },
      hours: [8, 12, 16],
      showLabels: true,
    },
    parking: {
      requiredCars: null,
      targetRatio: 1.0,
      ratioPerUnit: 1.0,
      assumedUnitArea: 70,
      stallW: 2.5,
      stallD: 5.0,
      keiRatio: 0,
      keiStallW: 2.0,
      keiStallD: 3.6,
      aisleW: AISLE_WIDTH_FIXED_M,
      aisleMinW: AISLE_WIDTH_FIXED_M,
      turnRadius: 6.0,
      siteClearance: 0.5,
      buildingClearance: 0.5,
      disabledCount: 0,
      guestCount: 0,
      evCount: 0,
      cellSize: 0.5,
      angleMode: 'auto',
      manualAngleDeg: 0,
      rowsAlongXMode: 'auto',
      roadDirectEdgeIndices: null,
      methods,
      generatedSlots: [],
      lanes: [],
      capacity: 0,
      drivewayConnectors: [],
      circulationWarning: { disconnectedLaneIndices: [], disconnectedCount: 0 },
    },
    bicycle: {
      requiredCount: null,
      ratioPerUnit: 1.0,
      unitArea: 0.6,
      assumedUnitArea: 70,
      enabled: false,
      autoZone: true,
      zone: null,
      capacity: 0,
    },
  };
}
